import React from 'react';
import { Modal, Form, Input, DatePicker } from 'antd';
import moment from 'moment';
  
  const HolidayDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {

      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Holiday"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
            <Form.Item label="Holiday Name">
                    {getFieldDecorator('holidayName', {
                      initialValue: data.holidayName,
                      rules: [{ required: true, message: 'What is the name of the holiday ?' }],
                    })(
                      <Input />
                    )}
              </Form.Item>

              <Form.Item label="From">
                    {getFieldDecorator('fromDate', {
                      initialValue: moment(data.fromDate),
                      rules: [{ required: true, message: 'When does this holiday start?' }],
                    })(
                      <DatePicker format="YYYY-MM-DD" /> 
                    )}
              </Form.Item>

              <Form.Item label="To">
                    {getFieldDecorator('toDate', {
                      initialValue: moment(data.toDate),
                      rules: [{ required: true, message: 'When does this holiday end?' }],
                    })(
                      <DatePicker format="YYYY-MM-DD" /> 
                    )}
              </Form.Item>
              
            </Form>

          </Modal>
        );
      }
    }
  );

  export default HolidayDialogForm;
